import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: '首頁', path: '/' },
    { name: '服務介紹', path: '/services' },
    { name: '作品案例', path: '/portfolio' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/dc383e0c56b0f6857f95d78b0119de75/b97b220c3b56990ab899488b4dd29485.jpeg" 
              alt="GELi 閣立室內裝修" 
              className="h-12 w-12 object-contain rounded-lg"
            />
            <div className="flex flex-col">
              <span className={`text-2xl font-bold font-serif transition-colors ${
                isScrolled ? 'text-primary' : 'text-white'
              }`}>
                GELi 閣立
              </span>
              <span className={`text-xs transition-colors ${
                isScrolled ? 'text-gray-600' : 'text-white/90'
              }`}>
                閣立室內裝修
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-primary'
                      : 'text-white'
                    : isScrolled
                    ? 'text-gray-600 hover:text-primary'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <a
              href="https://lin.ee/JAWndnI"
              target="_blank"
              rel="noopener noreferrer"
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                isScrolled
                  ? 'bg-primary text-white hover:bg-primary/90'
                  : 'bg-white text-primary hover:bg-white/90'
              }`}
            >
              <i className="ri-message-3-line mr-2"></i>
              LINE諮詢
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}